import { HttpErrorResponse } from '@angular/common/http';
import { Action, createActionGroup, emptyProps, props } from '@ngrx/store';

export const configurationsActions = createActionGroup({
    source: '[Aumico-Core] configurationsActions',
    events: {
        'Get Supported Locales': emptyProps(),
        'Get Supported Locales Success': props<{ payload: string[] }>(),
        'Get Supported Locales Failed': props<{ payload: HttpErrorResponse }>(),
    },
});

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
